import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'generalFilter' })
export class GeneralFilterPipe implements PipeTransform {
  transform(items: any[], searchString: string, properties: string[]): any[] {
    if (!items || !searchString || !properties || properties.length === 0) {
      return items;
    }
    searchString = searchString.toLowerCase();

    return items.filter((item) =>
      properties.some((property) =>
        this.getPropertyValue(item, property)
          ?.toString()
          .toLowerCase()
          .includes(searchString),
      ),
    );
  }

  private getPropertyValue(item: any, property: string): any {
    return property.split('.').reduce((obj, key) => obj?.[key], item);
  }
}
